import type { IResultsResponse } from '@smiles/core-traveler-universe/dist/Types/Hotels/Results.types';

export const Types = {
  SET_RESULTS: 'results/SET_RESULTS',
  SET_HOTELS_LIST: 'results/SET_HOTELS_LIST',
};

export interface IResultsReduxState extends Omit<IResultsResponse, 'hotelAvail'> {
  hotelsFullList: IResultsResponse['hotelAvail']['hotelAvail'];
  hotelsList: IResultsResponse['hotelAvail']['hotelAvail'];
}

const initialState: IResultsReduxState = {
  daily: 0,
  hotelsFullList: [],
  hotelsList: [],
  rooms: 0,
};

export default function reducer(state = initialState, action: any = {}): IResultsReduxState {
  switch (action.type) {
    case Types.SET_RESULTS:
      return { ...state, ...action.payload };
    case Types.SET_HOTELS_LIST:
      return { ...state, hotelsList: action.payload };
    default:
      return state;
  }
}

const setResults = (results: IResultsReduxState) => ({
  type: Types.SET_RESULTS,
  payload: results,
});

const setHotelsList = (hotelsList: IResultsReduxState['hotelsList']) => ({
  type: Types.SET_HOTELS_LIST,
  payload: hotelsList,
});

export const resultsActions = {
  setResults,
  setHotelsList,
};
